import { render, staticRenderFns } from "./PsiFormSection.vue?vue&type=template&id=f7dde794&scoped=true&"
import script from "./PsiFormSection.vue?vue&type=script&lang=js&"
export * from "./PsiFormSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7dde794",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VForm,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7dde794')) {
      api.createRecord('f7dde794', component.options)
    } else {
      api.reload('f7dde794', component.options)
    }
    module.hot.accept("./PsiFormSection.vue?vue&type=template&id=f7dde794&scoped=true&", function () {
      api.rerender('f7dde794', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/src/components/forms/PsiFormSection.vue"
export default component.exports